import SessionPill from '../../../../../components/SessionPill';
import { SESSION_STRUCTURE } from '../../constants';
import {
  SectionWrapper,
  GridContainer,
  LeftColumn,
  SessionTitle,
  RightColumn,
  SessionItemsContainer,
} from './styles';

const WhatSessionLooksLikeSection = () => {
  return (
    <SectionWrapper>
      <GridContainer>
        <LeftColumn>
          <SessionTitle>What a Session Looks Like</SessionTitle>
        </LeftColumn>

        <RightColumn>
          <SessionItemsContainer>
            {SESSION_STRUCTURE.map((item, index) => (
              <SessionPill key={index}>{item}</SessionPill>
            ))}
          </SessionItemsContainer>
        </RightColumn>
      </GridContainer>
    </SectionWrapper>
  );
};

export default WhatSessionLooksLikeSection;
